import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(item => ({
        value: item.eventId,
        label: `${item.eventId} - ${item.description}`,
        eventId: item.eventId,
        description: item.description,
        CIDCode: item.CIDCode,
        CIDDescription: item.CIDDescription
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }) {
      try {
        const { data } = await axios.get('v1/bosch/events-definition');

        if (!data || !data.data) {
          return []
        }

        commit('setData', data.data);
        return data.data;

      } catch (error) {
        console.error('Error fetching event definitions:', error);
        return [];
      }
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
